import { render } from "./Infographics.vue?vue&type=template&id=5e2e67bc"
import script from "./Infographics.vue?vue&type=script&lang=js"
export * from "./Infographics.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__